import React, { useEffect, useRef, useState } from "react";
import CustomInput from "../../../Component/BasicComponents/CustomInput";
// import ReusableDropdown from "../../../Component/BasicComponents/Dropdowns/Dropdown";
import { Btn } from "../../../AbstractElements";
import RouteDropdown from "../../../Component/BasicComponents/Dropdowns/RouteDropdown";
import { handleMedia } from "../../ProductCatalogue/repositories/BrandCampaignRepository";
import {
  useCityAndStateData,
  useClassificationData,
  useStateListData,
  useUpdateOnboardAddress,
  useVisitFrequencyData,
} from "../hooks/useOnBoard";
import { useBeatData } from "../../FSM/Beats_Patches/hooks/useBeat";
import PaginatedRouteDropdown from "../../../Component/BasicComponents/Dropdowns/PaginatedDropdownWrapper";
import { getAllTowns, sendMediaIds } from "../hooks/OnBoardingRepo";
import { getBeats } from "../../FSM/Beats_Patches/hooks/BeatRepository";
import { useGetOutletTypeListData } from "../../ProductCatalogue/hooks/useBrandCampaign";
import { showToast } from "../../../utils/toastUtils";
import { FaTrash } from "react-icons/fa";
import pdf from "../../../assets/images/pdf_image.png";
import { handleMediaAndFile } from "../../edetailing/repository/EdetailingRepository";

// handleMediaAndFile
type Props = {
  orgUnitIds: string;
  EDMDetailsData?: any;
  selectedRowData?: any;
  setIsEditOpen?: any;
  singleAddress?: any;
};

function OnboardingAddressModalContent({
  orgUnitIds,
  EDMDetailsData,
  selectedRowData,
  setIsEditOpen,
  singleAddress,
}: Props) {
  // getAllTowns
  const [formData, setFormData] = useState({
    media: "",
    beat: "",
    visit_frequency: "",
    classification: "",
    outletType: "",
    name: "",
    address: "",
    landmark: "",
    pincode: "",
    monthlyPotentialSales: "",
  });
  const [selectedTowns, setSelectedTowns] = useState<{
    id: number;
    label: string;
  } | null>(null);

  const [selectedCity, setSelectedCity] = useState<{
    id: number;
    label: string;
  } | null>(null);
  const [selectedState, setSelectedState] = useState<{
    id: number;
    label: string;
  } | null>(null);

  const [selectedBeat, setSelectedBeat] = useState<{
    id: number;
    label: string;
  } | null>(null);

  const [mediaIds, setMediaIds] = useState<string[]>([]);
  const [attachmentMediaData, setAttachmentMediaData] = useState([]);
  const [buttonDisable, setButtonDisable] = useState(false);

  const BASE_URL = "https://tspc-development.truesales.in/media?id=";
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleButtonClick = () => {
    fileInputRef.current?.click();
  };

  const mediaIdArray = (singleAddress?.SpportDocuments || "")
    .split(",")
    .map((id: string) => id.trim())
    .filter(Boolean);

  useEffect(() => {
    // initialize with old media + new media
    const oldMedia = selectedRowData?.SpportDocuments?.split(",") || [];
    const newMedia = formData?.media?.split(",") || [];
    setMediaIds([...new Set([...oldMedia, ...newMedia].filter(Boolean))]);
  }, [selectedRowData, formData?.media]);

  useEffect(() => {
    const fetchMediaIds = async () => {
      if (mediaIds.length > 0) {
        const response = await sendMediaIds(mediaIds);
        const attachmentData = response?.data;

        setAttachmentMediaData(attachmentData);

        // console.log(
        //   "🚀 ~ OnboardingAddressModalContent.tsx:99 ~ OnboardingAddressModalContent ~ res:",
        //   response?.data
        // );
      }
    };

    fetchMediaIds();
  }, [mediaIds]);

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(e.target.files || []);
    if (files.length === 0) return;

    // 🟢 Calculate how many more files can be added
    const remainingSlots = 3 - mediaIds.length;

    if (remainingSlots <= 0) {
      alert("You can upload a maximum of 3 files.");
      return;
    }

    // 🟢 Warn if user selects more than allowed
    if (files.length > remainingSlots) {
      showToast.warning(
        `You can only add ${remainingSlots} more file(s). Extra files will be ignored.`
      );
    }

    // 🟢 Trim to allowed files
    const limitedFiles = files.slice(0, remainingSlots);

    try {
      // Upload each file using handleMedia (supports both images + PDFs)
      const uploadPromises = limitedFiles.map((file) =>
        handleMediaAndFile(file)
      );
      const newIds = await Promise.all(uploadPromises);

      // 🟢 Update state without duplicates
      setMediaIds((prev) => [...new Set([...prev, ...newIds])]);
    } catch (error) {
      console.error("Upload failed:", error);
      showToast.error("One or more files failed to upload.");
    } finally {
      // Clear input so user can reselect the same file if needed
      e.target.value = "";
    }
  };

  const handleRemoveImage = (id: string) => {
    setMediaIds((prev) => prev.filter((mediaId) => mediaId != id));
  };

  // const { data: VisitFrequencyData } = useVisitFrequencyData({ enable: true });
  const { data: stateFilterData } = useStateListData({ enable: true });
  const { data: beatsData } = useBeatData({
    enable: EDMDetailsData?.data?.Territory ? true : false,
    params: {
      TerritoryId: EDMDetailsData?.data?.Territory,
      TownId: "",
      limit: 10,
      page: 1,
      search: "",
    },
  });

  const { data: outletTypeList } = useGetOutletTypeListData({ enable: true });

  const { data: classificationData } = useClassificationData({
    enable: true,
    params: {
      page: 1,
      limit: 10,
      search: "",
      fetch: "all",
    },
  });

  const { data: city_state } = useCityAndStateData({
    enable: !!selectedTowns,
    params: { townId: selectedTowns?.id },
  });

  const { mutate: updateAddress } = useUpdateOnboardAddress();

  useEffect(() => {
    if (cityOptions.length === 1) setSelectedCity(cityOptions[0]);
    if (stateOptions.length === 1) setSelectedState(stateOptions[0]);
  }, [city_state]);

  // const visitFrequencyFormattedData = VisitFrequencyData?.data?.map(
  //   (item: any) => ({
  //     id: item,
  //     label: item,
  //   })
  // );

  const cityOptions =
    city_state?.data?.map((item: any) => ({
      id: item.CityId,
      label: item.CityName.trim(),
    })) || [];

  const stateOptions =
    city_state?.data?.map((item: any) => ({
      id: item.StateId,
      label: item.StateName.trim(),
    })) || [];

  const stateFilterFormattedData = Object.entries(
    stateFilterData?.data?.data || {}
  ).map((item: any) => ({
    id: item[0],
    label: item[1].trim(),
  }));

  const formattedClassificationData =
    Object.entries(classificationData?.data?.Classifications || {}).map(
      (item: any) => ({
        id: item[0],
        label: item[1] as string,
      })
    ) || [];

  const outletTypeListFormattedData =
    outletTypeList?.data?.map((item: any, index: any) => ({
      id: item?.OutlettypeId,
      label: item?.OutlettypeName,
    })) || [];

  const handleClose = () => setIsEditOpen(false);

  const handleDropdownSelect = (field: string, value: string | number) => {
    setFormData((prevState: any) => ({
      ...prevState,
      [field]: value, // Directly assign the selected value
    }));
  };

  const handleInputChange = (
    name: any,
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { value } = e.target;

    if (name === "policyYear") {
      const numericValue = value.replace(/[^0-9]/g, ""); // allow only numbers
      if (numericValue.length <= 4) {
        setFormData((prevState) => ({
          ...prevState,
          [name]: numericValue,
        }));
      }
      return;
    }

    // Convert specific fields to numbers
    const numericFields = ["monthlyPotentialSales", "visit_frequency"];
    const updatedValue = numericFields.includes(name)
      ? value.replace(/[^0-9]/g, "")
      : value;

    setFormData((prevState) => ({
      ...prevState,
      [name]: numericFields.includes(name)
        ? updatedValue === ""
          ? ""
          : Number(updatedValue)
        : updatedValue,
    }));
  };

  useEffect(() => {
    if (selectedRowData && singleAddress?.Classification?.Id) {
      setFormData({
        media: selectedRowData?.MediaId || "",
        beat: "",
        visit_frequency: selectedRowData?.VisitFrequency || "",
        classification: singleAddress?.Classification?.Id || "",
        outletType: selectedRowData?.OutletSubTypeId || "",
        name: selectedRowData?.Name || "",
        address: selectedRowData?.Address || "",
        landmark: selectedRowData?.Landmark || "",
        pincode: selectedRowData?.Pincode || "",
        monthlyPotentialSales: selectedRowData?.Potential || "",
      });

      // setSelectedCity(selectedRowData?.Icityid);

      // Pre-select dropdowns that need { id, label }
      if (selectedRowData?.Itownid && selectedRowData?.TownName) {
        setSelectedTowns({
          id: Number(selectedRowData.Itownid),
          label: selectedRowData.TownName,
        });
      }

      if (selectedRowData?.Icityid && selectedRowData?.CityName) {
        setSelectedCity({
          id: Number(selectedRowData.Icityid),
          label: selectedRowData.CityName,
        });
      }

      if (selectedRowData?.Istateid && selectedRowData?.StateName) {
        setSelectedState({
          id: Number(selectedRowData.Istateid),
          label: selectedRowData.StateName,
        });
      }

      if (selectedRowData?.BeatId && selectedRowData?.BeatName) {
        setSelectedBeat({
          id: Number(selectedRowData.BeatId),
          label: selectedRowData.BeatName,
        });
      }
    }
  }, [selectedRowData, singleAddress]);

  console.log("MEDIA IDS:::::::::", mediaIds.join(","));

  const handleSubmit = () => {
    setButtonDisable(true);

    const updateAddressBody = {
      Address: formData?.address,
      Landmark: formData?.landmark,
      Icityid: selectedCity?.id,
      Itownid: selectedTowns?.id,
      Istateid: selectedState?.id,
      beat_id: Number(selectedBeat?.id),
      Pincode: formData?.pincode,
      OutletSubTypeId: formData?.outletType,
      Speciality: formData?.classification,
      Potential: formData?.monthlyPotentialSales,
      VisitFrequency: formData?.visit_frequency,
      Tags: "",
      FocusBrand: "",
      SpportDocuments: mediaIds.join(","), // ✅ sending both old + new
    };

    updateAddress(
      { id: selectedRowData?.OnBoardRequestAddressId, body: updateAddressBody },
      {
        onSuccess: () => {
          handleClose();
          resetForm();
        },
        onSettled: () => {
          // handleClose();
          // resetForm();
          setButtonDisable(false);
        },
      }
    );
  };

  const resetForm = () => {
    setFormData({
      media: "",
      beat: "",
      visit_frequency: "",
      classification: "",
      outletType: "",
      name: "",
      address: "",
      landmark: "",
      pincode: "",
      monthlyPotentialSales: "",
    });
    setSelectedBeat(null);
    setSelectedCity(null);
    setSelectedState(null);
    setSelectedTowns(null);
    setButtonDisable(false);
  };

  return (
    <div>
      <div className="row mb-0">
        <div className="col-sm-6">
          <RouteDropdown
            options={outletTypeListFormattedData || []}
            value={formData.outletType}
            onChange={(value: any) => {
              handleDropdownSelect("outletType", value);
            }}
            DropdownHeading="Outlet Type"
          />
        </div>
        <div className="col-sm-6">
          <CustomInput
            label="Address"
            placeholder="Enter Address"
            type="text"
            name="address"
            value={formData.address}
            onChange={(e) => handleInputChange("address", e)}
          />
        </div>
        <div className="col-sm-6">
          <CustomInput
            label="Landmark"
            placeholder="Enter Landmark"
            type="text"
            name="landmark"
            value={formData.landmark}
            onChange={(e) => handleInputChange("landmark", e)}
          />
        </div>
        <div className="col-sm-6">
          <PaginatedRouteDropdown
            DropdownHeading="Towns"
            initialSelectedOptions={selectedTowns} // ✅ Only for showing selected
            onChange={(val: any) => {
              // ✅ You must get { id, label } back (see fix below in component)
              setSelectedTowns(val);
            }}
            fetchOptions={async (page: any, search: any) => {
              const res = await getAllTowns({
                page,
                limit: 10,
                search: search || "",
              });
              return Object.entries(res?.data?.TownsData || {}).map((item) => ({
                id: item[0],
                label: item[1] as string,
              }));
            }}
          />
        </div>
        <div className="col-sm-6">
          <CustomInput
            label="Pincode"
            placeholder="Enter Pincode"
            type="text"
            name="pincode"
            value={formData.pincode}
            onChange={(e) => handleInputChange("pincode", e)}
          />
        </div>
        <div className="col-sm-6">
          <RouteDropdown
            options={cityOptions}
            value={selectedCity?.id}
            onChange={(value: string | number | (string | number)[]) => {
              if (typeof value === "string" || typeof value === "number") {
                const selected = cityOptions.find(
                  (opt: any) => opt.id === Number(value)
                );
                setSelectedCity(selected || null);
              } else {
                // Handle multi-select if needed, or just ignore for now
                console.warn("Multi-select not supported here.");
              }
            }}
            DropdownHeading="City"
            placeholder="Select City"
          />
        </div>
        <div className="col-sm-6">
          <RouteDropdown
            options={stateOptions}
            value={selectedState?.id}
            onChange={(value: string | number | (string | number)[]) => {
              if (typeof value === "string" || typeof value === "number") {
                const selected = stateOptions.find(
                  (opt: any) => opt.id === Number(value)
                );
                setSelectedState(selected || null);
              } else {
                console.warn("Multi-select not supported here.");
              }
            }}
            DropdownHeading="State"
            placeholder="Select State"
          />
        </div>
        <div className="col-sm-6">
          <PaginatedRouteDropdown
            DropdownHeading="Beats"
            initialSelectedOptions={selectedBeat} // ✅ Only for showing selected
            onChange={(val: any) => {
              // ✅ You must get { id, label } back (see fix below in component)
              console.warn("beats onchange data:::::::::", val);
              setSelectedBeat(val);
            }}
            fetchOptions={async (page: any, search: any) => {
              const res = await getBeats({
                TerritoryId: EDMDetailsData?.data?.Territory,
                TownId: "",
                limit: 10,
                page,
                search: search || "",
              });

              return res?.data?.data?.map((item: any) => ({
                id: item?.BeatId,
                label: item?.BeatName,
              }));
            }}
          />
        </div>
        <div className="col-sm-6">
          <CustomInput
            label="Visit Frequency"
            placeholder="Enter Visit Freqeuncy"
            type="number"
            name="visit_frequency"
            value={formData.visit_frequency}
            onChange={(e) => handleInputChange("visit_frequency", e)}
          />
        </div>

        <div className="col-sm-6">
          <RouteDropdown
            options={formattedClassificationData || []}
            value={formData?.classification}
            onChange={(value: any) => {
              handleDropdownSelect("classification", value);
            }}
            DropdownHeading="Classification"
          />
        </div>
        <div className="col-sm-6">
          <CustomInput
            label="Potential Monthly Sales"
            placeholder="Enter Potential Monthly Sales"
            type="text"
            name="name"
            value={formData.monthlyPotentialSales}
            onChange={(e) => handleInputChange("monthlyPotentialSales", e)}
          />
        </div>
        {mediaIds.length < 3 ? (
          <div style={{ marginTop: "2.5rem" }} className="col-sm-6">
            <input
              type="file"
              accept=".pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .txt"
              multiple // ✅ this is required
              ref={fileInputRef}
              onChange={handleFileChange}
              style={{ display: "none" }}
            />
            <Btn
              style={{
                display: "flex",
                backgroundColor: "#43B9B2",
                color: "white",
                justifyContent: "center",
                alignItems: "end",
              }}
              type="submit"
              onClick={handleButtonClick}
            >
              {"Upload Attachment"}
            </Btn>
          </div>
        ) : (
          <div style={{ marginTop: "2.5rem" }} className="col-sm-6"></div>
        )}

        {attachmentMediaData.length > 0 && (
          <div className="row mb-3">
            <label style={{ fontWeight: "500", display: "block" }}>
              Uploaded Attachment
            </label>

            {attachmentMediaData.map((media: any) => (
              <div
                key={media.MediaId}
                className="col-md-2 mb-2"
                style={{ position: "relative" }}
              >
                {media.MediaMime.startsWith("image/") ? (
                  <img
                    src={`${BASE_URL}${media.MediaId}`}
                    alt={media.MediaName}
                    style={{
                      width: "100px",
                      height: "100px",
                      borderRadius: "8px",
                      objectFit: "cover",
                      marginTop: "8px",
                    }}
                  />
                ) : media.MediaMime === "application/pdf" ? (
                  <>
                    <img
                      src={pdf}
                      alt={media.MediaName}
                      style={{
                        width: "100%",
                        height: "auto",
                        maxHeight: "280px",
                        objectFit: "contain",
                        borderRadius: "8px",
                        boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)",
                        // display: imageLoading ? "none" : "block",
                        cursor: "pointer",
                      }}
                      onClick={() =>
                        window.open(`${BASE_URL}${media.MediaId}`, "_blank")
                      }
                    />

                    <p style={{ marginTop: "10px", fontSize: "14px" }}>
                      {media.MediaName}
                    </p>
                  </>
                ) : (
                  <span>Unsupported</span>
                )}

                <button
                  type="button"
                  onClick={() => handleRemoveImage(media.MediaId)}
                  style={{
                    position: "absolute",
                    top: "5px",
                    right: "5px",
                    background: "rgba(0,0,0,0.6)",
                    border: "none",
                    borderRadius: "50%",
                    padding: "4px",
                    cursor: "pointer",
                    color: "white",
                  }}
                >
                  <FaTrash size={12} />
                </button>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Buttons */}
      <div className="d-flex justify-content-start gap-2">
        <Btn
          style={{ backgroundColor: "#43B9B2", color: "white" }}
          type="submit"
          onClick={handleSubmit}
          disabled={buttonDisable}
        >
          {buttonDisable === false ? "Update" : "Updating..."}
        </Btn>
        <Btn
          style={{
            backgroundColor: "#F9FAFC",
            color: "#000",
            border: "1px solid #E0E0E0",
          }}
          type="button"
          onClick={handleClose}
        >
          Cancel
        </Btn>
      </div>
    </div>
  );
}

export default OnboardingAddressModalContent;
